import { renderComponent, renderBreakingNews, renderIsomorphicComponent } from "@quintype/framework/client/start";
import { BreakingNewsView } from "../isomorphic/components/breaking-news/breaking-news-view";
import { pickComponent } from "../isomorphic/pick-component";
import { Metype } from "../isomorphic/components/metype.js";
import { Footer } from "../isomorphic/components/footer/footer.js";
import { LoadingIndicatorComponent } from "../isomorphic/components/basic/loading-indicator.js";
import { pickHeader } from "../isomorphic/pick-header";
import { InjectWidget } from "../isomorphic/components/inject-widget";
import { MeteredStoryIndicator } from "../isomorphic/components/basic/metered-story-indicator/metered-story-indicator";
import { SSOWrapper } from "../isomorphic/components/sso-components/sso-dynamic";

export function preRenderApplication(store) {
  const themeAttributes = store.getState().qt.config["theme-attributes"];
  const headerTheme = "header";

  pickHeader(headerTheme).then(header => renderComponent(header.default, "navbar", store));

  if (!themeAttributes.hide_breaking_news) renderBreakingNews("breaking-news-container", store, BreakingNewsView);

  renderComponent(InjectWidget, "widget", store);

  // Delayed by 3s for perf
  global.setTimeout(() => renderComponent(Metype, "meType", store), 3000);

  renderComponent(Footer, "footer", store);
}

// This is a separate file as everything from here on is hot reloaded when the app changes
export function renderApplication(store) {
  if (global.location.hash === "#secret-mode") {
    import(/* webpackChunkName: "secret-mode" */ "./secret-mode").then(({ startSecretMode }) => startSecretMode(store));
  }
  renderIsomorphicComponent("container", store, pickComponent, { hydrate: !global.qtLoadedFromShell });
  renderBreakingNews("breaking-news-container", store, BreakingNewsView);
  renderComponent(LoadingIndicatorComponent, "loading-indicator", store);
  renderComponent(SSOWrapper, "sso-wrapper", store);
  renderComponent(MeteredStoryIndicator, "metered-story-indicator", store);
}
